
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";

    import Utils from "@/utilities/Utils";
    import PrimaryButton from "@/vue/components/PrimaryButton.vue";

    import PrintTextBox from "@/vue/components/PrintForm/PrintTextBox.vue";
    import PrintTextArea from "@/vue/components/PrintForm/PrintTextArea.vue";
    import PrintCheckbox from "@/vue/components/PrintForm/PrintCheckbox.vue";
    import PrintDatePicker from "@/vue/components/PrintForm/PrintDatePicker.vue";
    import PrintDateTimePicker from "@/vue/components/PrintForm/PrintDateTimePicker.vue";
    import PrintSelect from "@/vue/components/PrintForm/PrintSelect.vue";

    import { WorkPermit } from "@/model/workPermits/WorkPermit";
    import { Site } from "@/model/Site";
    import { SwmScapaHazard } from "@/model/workPermits/SwmScapaHazard";
    import { ILookupItem, LookupItem } from "@/model/LookupItem";

    @Component({
        components: {
            PrimaryButton,
            PrintDatePicker,
            PrintDateTimePicker,
            PrintTextBox,
            PrintTextArea,
            PrintCheckbox,
            PrintSelect
        }
    })
    export default class SouthEasternAfterPart extends Vue {

        @Prop({ required: true }) workPermit!: WorkPermit;
        @Prop({ default: false }) isReadOnly!: boolean;
        @Prop({ required: true }) site!: Site;

        // TODO - hazards stuff...

        addhazard() {
            if(!this.workPermit.swmScapaFieldSet.hazardsAndControlMeasures) {
                this.workPermit.swmScapaFieldSet.hazardsAndControlMeasures = [];
            }
            const hazard = new SwmScapaHazard();
            hazard.id = Utils.createKey(6); // not a DB id as such
            this.workPermit.swmScapaFieldSet.hazardsAndControlMeasures.push(hazard);
        }

        removeHazard(item: SwmScapaHazard) {
            const index = this.workPermit.swmScapaFieldSet.hazardsAndControlMeasures.indexOf(item);
            if (index > -1) this.workPermit.swmScapaFieldSet.hazardsAndControlMeasures.splice(index, 1);
        }

    }
